/**
 * Matching Accessories
 */
import 'jquery-match-height';
import 'slick-carousel';

// Module template
import './_matching-accessories.twig';

// Module styles
import './_matching-accessories.scss';

export const name = 'matching-accessories';

// Export functions for enable/disable
export function disable() {}

(function ($, Drupal) {
  // Function to uncheck 'Show All'
  Drupal.behaviors.accordion = {
    attach: function attach($context) {
      function uncheckShowAll() {
        // Get the 'Show All' checkbox
        const showAllCheckbox = document.getElementById('show-all-checkbox');
        // Uncheck the checkbox
        showAllCheckbox.checked = false;
        // Get the corresponding list item and remove the 'active' class
        const liElementShowAll = document.querySelector('li.show-all');
        liElementShowAll.classList.remove('active');
      }

      // Function to check if all checkboxes are active
      function checkAllCheckboxes() {
        const checkboxIds = ['mandatory', 'related', 'similar'];
        const showAllCheckbox = document.getElementById('show-all-checkbox');

        const allCheckboxesChecked = checkboxIds.every((id) => {
          const checkbox = document.getElementById(`${id}-checkbox`);
          return checkbox ? checkbox.checked : true;
        });

        if (allCheckboxesChecked) {
          // If all are checked, add 'active' class to 'Show All'
          showAllCheckbox.checked = true;
          const showAllLiElement = document.querySelector('li.show-all');
          showAllLiElement.classList.add('active');
        }
      }

      // Function to toggle accordion status
      function toggleAccordion(status) {
        // Get the checkbox, accordion element, and list item associated with the given status
        const accordionCheckbox = document.getElementById(`${status}-checkbox`);
        const accordion = document.getElementById(
          status.toLowerCase().replace(' ', '-')
        );
        const liElement = document.querySelector(`li.${status.toLowerCase()}`);

        if (accordionCheckbox && accordion && liElement) {
          if (accordionCheckbox.checked) {
            // If the checkbox is checked, add 'active' class and show the accordion
            liElement.classList.add('active');
            accordion.classList.add('active');
            accordion.classList.remove('hide');
          } else {
            // If the checkbox is unchecked
            liElement.classList.remove('active');
            accordion.classList.remove('active');

            // Check if any other checkbox is checked
            const atLeastOneChecked = Array.from(
              document.querySelectorAll('.status-tabs input[type="checkbox"]')
            ).some(function (checkbox) {
              return checkbox.checked && checkbox.id !== accordionCheckbox.id;
            });

            if (!atLeastOneChecked) {
              // If none are checked, prevent unchecking the current checkbox
              accordionCheckbox.checked = true;
              liElement.classList.add('active');
              accordion.classList.add('active');
            }

            // Uncheck 'Show All' if needed
            uncheckShowAll();
          }
        }
        checkAllCheckboxes();
      }

      // Function to toggle 'Show All'
      function toggleShowAll() {
        // Get the 'Show All' checkbox, all checkboxes, and the 'Show All' list item
        const showAllCheckbox = document.getElementById('show-all-checkbox');
        const checkboxes = document.querySelectorAll(
          '.status-tabs input[type="checkbox"]'
        );
        const showAllLiElement = document.querySelector('li.show-all');

        // Check the 'Show All' checkbox and update the UI
        showAllCheckbox.checked = true;
        showAllLiElement.classList.add('active');

        checkboxes.forEach(function (checkbox) {
          if (showAllCheckbox.checked) {
            // Only check other checkboxes if 'Show All' is checked
            checkbox.checked = true;
          }
          // Toggle accordion based on the checkbox's status
          toggleAccordion(checkbox.id.split('-')[0]);
        });

        // Toggle hide class on all accordion elements
        const accordions = document.querySelectorAll('.accordion');
        accordions.forEach(function (accordion) {
          accordion.classList.remove('hide');
        });
      }

      // Expose functions to the global scope
      window.toggleShowAll = toggleShowAll;
      window.toggleAccordion = toggleAccordion;
      window.uncheckShowAll = uncheckShowAll;

      // Add click event listeners to all accordion elements
      const accordionElements = document.getElementsByClassName(
        'accordion-header'
      );
      for (let i = 0; i < accordionElements.length; i++) {
        accordionElements[i].addEventListener('click', function () {
          // Toggle the 'hide' class on click
          this.parentElement.classList.toggle('hide');
        });
      }

      // Find our component within the DOM
      const $accessoryItems = $('.acessory-slider', $context);
      // Bail if component does not exist
      if (!$accessoryItems.length) {
        return;
      }

      function initCarousel($accessoryWrapper) {
        $accessoryWrapper.slick({
          infinite: false,
          arrows: true,
          mobileFirst: true,
          accessibility: true,
          respondTo: 'window',
          touchMove: true,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }

      function updateHeight($item) {
        // Match height for title.
        $item.find('.product-item__title').matchHeight({
          byRow: false,
          property: 'height',
          target: null,
          remove: false,
        });
      }

      // Initiate slick
      $accessoryItems.each(function initiateSlick(i, el) {
        const $accessoryItem = $(el);
        // Create an Intersection Observer instance
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // If slick is initialized then just refresh it to
              // avoid broken when switching between sliders
              if ($(entry.target).hasClass('slick-initialized')) {
                $accessoryItem.slick('refresh');
              } else {
                initCarousel($accessoryItem);
                updateHeight($accessoryItem);
              }
            }
          });
        });
        // Start observing the "matching-accessory-item" slider element
        observer.observe($(this)[0]);
      });
    },
  };
})(jQuery, Drupal);
